import React, { ReactNode } from 'react';
import { Stack, Typography, Box, SxProps, Theme } from '@mui/material';
import { colors } from '../../../assets/themes/colors.ts';
import { isNotNullOrUndefined } from '@vy/utils';

interface FormSectionProps {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
  sx?: SxProps<Theme>;
}

export const VyFormSection = ({ title, icon, children, actions, sx }: FormSectionProps) => {
  return (
    <Stack spacing={1} sx={sx}>
      <Stack direction="row" sx={{
        justifyContent: "space-between"
      }}>
        <Stack direction="row" spacing={1} sx={{
          alignItems: "center"
        }}>
          {isNotNullOrUndefined(icon) && icon}

          <Box>
            <Typography
              sx={{
                fontSize: 16,
                color: colors.grey[90]
              }}>
              {title}
            </Typography>
          </Box>
        </Stack>
        {isNotNullOrUndefined(actions) && <Box>{actions}</Box>}
      </Stack>
      <Box sx={{ padding: 3, border: 1, borderColor: colors.grey[30], borderRadius: 2 }}>{children}</Box>
    </Stack>
  );
};
